<template lang="html">
  <div class="selectable-item"
       :class="{'selectable-item--active': selectable && selected}"
       @click="onItemClicked">
    <img v-if="selectable && selected"
         src="@/assets/views/models/selected.png"
         class="selectable-item__indicator"
         :style="indicatorStyle">
    <img v-else
         src="@/assets/views/models/unselected.png"
         :style="indicatorStyle"
         class="selectable-item__indicator"
         :class="{'selectable-item__indicator--invisible': !selectable || mode === 'default'}">
    <img :src="src" class="selectable-item__image">
  </div>
</template>

<script>
export default {
  name: 'SelectableItem',
  props: {
    selected: { type: Boolean, default: false },
    src: { type: String, default: '' },
    mode: { type: String, default: 'default' },
    selectable: { type: Boolean, default: true },
    markSize: { type: Number, default: 10 }
  },
  data: () => ({}),
  computed: {
    indicatorStyle() {
      return {
        width: `${this.markSize}px`,
        height: `${this.markSize}px`,
        top: `${this.markSize * 0.3}px`,
        right: `${this.markSize * 0.3}px`
      };
    }
  },
  methods: {
    onItemClicked(e) {
      if (this.mode === 'select') {
        this.$emit('update:selected', !this.selected);
      }
      if (this.mode === 'default') {
        this.$emit('click', e);
      }
      e.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
.selectable-item {
  display: inline-block;
  border: 1px solid #d9d9d9;
  transition: .15s;
  cursor: pointer;
  position: relative;
  background-color: white;

  &:hover {
    border: 1px solid #108ee9;
  }

  &--active {
    border: 1px solid #108ee9;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__indicator {
    position: absolute;
    user-select: none;

    &--invisible {
      opacity: 0;
    }
  }
}
</style>
